/* eslint-disable no-console */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import HighchartsVue from "highcharts-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import PrimeGoogleMap from "@primayer/prime-google-map";
import { initializeApp } from "firebase/app";
import "firebase/messaging";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";
import Vuetify from "vuetify";
import Storage from "vue-ls";
import Vue2TouchEvents from "vue2-touch-events";
import VueCookies from "vue-cookies";
import Toasted from "vue-toasted";
//import Notification from "./models/Notification";
import CommonComponents from "@primayer/common-components";
import "@primayer/common-components/dist/common-components.css";
//import PermissionError from "./errors/PermissionError";
import "./helpers/Filters";

Vue.use(Vuetify, {
  iconfont: "mdi",
  theme: {
    // see https://vuetifyjs.com/en/framework/theme for more options
    primary: "#ffd732",
    secondary: "#666666",
    accent: "#6ed0f7",
    danger: "#d63737",
    background: "#fff",
    text: "#000"
  },
  options: {
    customProperties: true
  }
});

Vue.config.productionTip = false;
Vue.use(HighchartsVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAUViHzPrZIh0pnDW3YYKClM8zKQ5Bfjf4",
    libraries: "places,drawing,visualization"
  }
});
Vue.use(PrimeGoogleMap);
Vue.use(CommonComponents);

// https://github.com/RobinCK/vue-ls#readme
let storageOptions = {
  namespace: "FollowUp__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
};

Vue.use(Vue2TouchEvents);

Vue.use(Storage, storageOptions);

// https://github.com/cmp-cc/vue-cookies#readme
Vue.use(VueCookies);

// https://www.npmjs.com/package/vue-toasted
Vue.use(Toasted, {
  iconPack: "mdi",
  duration: 5000,
  position: "top-center",
  theme: "bubble",
  fullWidth: false
});

// options to the toast
let options = {
  type: "error",
  icon: "error_outline"
};

// register the toast with the custom message
Vue.toasted.register(
  "app_error",
  payload => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Oops.. Something Went Wrong..";
    }

    // if there is a message show it with the message
    return "Oops.. " + payload.message;
  },
  options
);

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored;
  next();
};

router.beforeEach((to, from, next) => {
  let token = Vue.ls.get("authToken", null);
  let user = Vue.ls.get("user", null);
  let forcePWReset = Vue.ls.get("resetPassword", false);
  if (token != null && user != null && forcePWReset) {
    if (to.path !== "/changePassword") {
      next("/changePassword");
    } else {
      next();
    }
  } else if (
    (token != null && user != null) ||
    to.name === "login" ||
    to.name === "forgotPassword"
  ) {
    waitForStorageToBeReady(to, from, next);
  } else {
    next({ name: "login" });
  }
});

// capture as many errors as we can to report back to base

Vue.config.errorHandler = err => {
  try {
    if (
      !err.message.includes("usePublicVapidKey()") ||
      err.message.includes("FireBase")
    ) {
      console.warn("vue caught error:", err);
      store.dispatch("errors/sendError", err, { root: true });
      store.dispatch("errors/unexpectedErrorAlert", err.name, { root: true });
    }
  } catch (error) {
    // stops errors calling into infinite loop
    console.error(error);
  }
};
window.onerror = function(message, source, lineno, colno, error) {
  try {
    console.warn("window caught error:", error);
    store.dispatch("errors/sendError", error, { root: true });
    store.dispatch("errors/unexpectedErrorAlert", error.name, { root: true });
  } catch {
    // stops errors calling into infinite loop
    console.error(error);
  }
};

new Vue({
  router,
  store,

  created() {
    // set default cookie config
    this.$cookies.config("7d", "", "", true, "Lax");
    // set up fire base when the instance is created
    var config = {
      apiKey: "AIzaSyAYVrEgiHTWWRnFak6RnLQSDy8BtRa2pPg",
      authDomain: "followup-d94e2.firebaseapp.com",
      databaseURL: "https://followup-d94e2.firebaseio.com",
      projectId: "followup-d94e2",
      storageBucket: "",
      messagingSenderId: "593657712239",
      appId: "1:593657712239:web:488812a58150ad8c22879a"
    };
    const app = initializeApp(config);

    // check local storage for a auth token and user id and set them to the store
    var token = Vue.ls.get("authToken", null); //if not set authToken return a default of null
    if (token) {
      this.$store.commit("login/setUserToken", token);
    }
    var userId = Vue.ls.get("user", null); //if not set authToken return a default of null
    if (userId) {
      this.$store.commit("login/setUserId", userId);
    }
    var authUser = Vue.ls.get("authUser", null); //if not set authToken return a default of null
    if (authUser) {
      this.$store.commit("login/setAuthUser", authUser);
    }
    const tokens = Vue.ls.get("tokens", null);
    if (tokens) {
      this.$store.commit("login/setTokens", tokens);
    }
    const messageToken = Vue.ls.get("messageToken", null);
    if (messageToken) {
      this.$store.commit("notifications/setMessageToken", messageToken);
    }
  },

  render: h => h(App)
}).$mount("#app");

router.replace("/").catch(() => {});
